import { createRouter, createWebHistory } from 'vue-router'
import Home from "../components/HomePage.vue"
import PatientPage from "../components/PatientPage.vue"
import NotFound from "../components/NotFound.vue"
import ErrorPage from "../components/ErrorPage.vue"

const routes = [
  {
    path: '/',
    name: 'patient',
    component: PatientPage,
    props: true,
  },
  {
    path: '/st/:st',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/error/:errorcode',
    name: 'ErrorPage',
    component: ErrorPage,
    props: true,
  },
  { 
    path: '/:pathMatch(.*)*', 
    name: 'NotFound', 
    component: NotFound 
  }
]

const router = createRouter( {
  history: createWebHistory(),
  routes
} )

export default router
